module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/144mg2u/Images/FC-9781528960168.jpg?1685790639642",
      "alt": "This image is the cover for the book Uzbe Is Missing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Uzbe Is Missing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Meat? Really? Starved, Uzbe swallowed it. But there was something in it. He suddenly felt so dizzy. His consciousness was fading out fast. He fell. Two men emerged from the heavy mist and put him in a sack. Uzbe was horrified. With his last energy, he whined: Dad, Mom, take this nightmare away…\tBut would he ever wake up at all?\tBali, 2008, Uzbe went missing. Him and his owners, a Canadian and Balinese couple, relentlessly searched for each other, navigating their way across dog-eating world and mass culling for rabies outcry in an island where social gaps, prejudice, and cultural clashes laid in a plain sight. The journey somehow brought the best of them and those they encountered along the way. Paradise can be deceiving. Hell can be uplifting. This is a tale inspired by true events that will make you wonder what should you feel.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Since she was a little girl selling fried banana in her hometown, Nan always lived her life her own way. When traveling was still a foreign concept in Indonesia, she already went backpacking alone or cruising on her dirt bike. She has traveled to many corners of the world and is counting. Experiencing different social and environmental landscapes has made her attached to conservation and animal-welfare issue. After finishing her postgraduate scholarships, she started working for several NGOs and co-founded Reef Check Foundation Indonesia. She now lives in Canada with her two dogs.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0